import { useWireState } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import LegalDescriptionWrapper from './LegalDescriptionWrapper'

const RunsheetLegalDescriptionModal = ({ setShowAdd, setEditRsDocJoin }) => {
    
    const [runsheetDocumentValue, setRunsheetDocumentValue] = useWireState(store.runsheetDocumentValue)
    
    const legalEmptyEntry = runsheetDocumentValue => order => ({
        runsheetDocumentValueId: runsheetDocumentValue?.id,
        documentId: runsheetDocumentValue?.documentId,
        original: '',
        summary: '',
        order,
        visible: true,
    })
    
    const onClose = newLegals => {
        if (runsheetDocumentValue.clickOrigin === 'edit-modal') {
            setEditRsDocJoin(docJoin => {
                docJoin.value = runsheetDocumentValue
                docJoin.value.legalDescriptions = newLegals || docJoin.value.legalDescriptions
                return { ...docJoin }
            })
            setShowAdd(true)
        }
        
        setRunsheetDocumentValue(null)
    }
    
    const onSave = async filteredLegals => {
        const newLegals = await actions.saveRunsheetLegals(runsheetDocumentValue.id, filteredLegals)
        
        onClose(newLegals)
    }
    
    return (
        <LegalDescriptionWrapper
            open={!!runsheetDocumentValue}
            hasVisible={true}
            legals={runsheetDocumentValue?.legalDescriptions || []}
            onClose={onClose}
            onSave={onSave}
            emptyEntryGenerator={legalEmptyEntry(runsheetDocumentValue)} />
    )
}

export default RunsheetLegalDescriptionModal
